<template>
    <b-container>
        <b-card
        :title="'Stake Name: ' + stakeInfo.stake_name + ', ' + stakeInfo.stake_city"
        >
        <b-row>
            <b-col>
        <b-dropdown text="Stake Actions" class="ml-3 mt-3 mb-3 mr-3">
            <b-dropdown-item v-if="isInRole('canModifyStake')" :to="{name: 'stake-edit', params: {stakeId: stakeId, wardId:null}}"><font-awesome-icon icon="edit" /> Edit Stake</b-dropdown-item>
            <b-dropdown-item v-if="isInRole('canModifyStake')" :to="{name: 'ward-create', params: {stakeId: stakeId, wardId:null}}"><font-awesome-icon icon="plus" /> Add Ward</b-dropdown-item>
        </b-dropdown>          
            </b-col>
        </b-row>
        <b-row>
            <b-col>
        <b-table
            :fields="table.fields"
            :items="table.items"
            class="ml-3 mr-3"
            show-empty
            responsive
            empty-text="No Wards to show"            
            outlined>
            <template v-slot:cell(ward_city)="row">
                {{row.item.ward_city}}
            </template>            
            <template v-slot:cell(action)="row">
                <b-button :key="row.item.id" :to="{name: 'ward-list', params: { wardId: row.item.ward_id}}" variant="outline-secondary"> 
                <font-awesome-icon icon="eye" />
                </b-button>

                <b-button @click="deleteWard(row.item)" class="ml-2" type="button" variant="danger" v-if="isInRole('canDeleteWard')">
                    <font-awesome-icon icon="trash" />
                </b-button>

                <b-button @click="wardTools(row.item)" class="ml-2" type="button" variant="secondary">
                    <font-awesome-icon icon="server" />
                </b-button>                
            </template>            
        </b-table>
            </b-col>
        </b-row>
        </b-card>
    </b-container>
</template>
<script>
import { StakeApi } from "@/app/stakes/stakeApi";
import { userMixin } from "@/mixins/userMixin";
import handleError from "@/errorHandler";
export default {
    name: "StakeDetail",
    props: {
        stakeId: {
            type: String,
            required: false,
            default: null
        }
    },    
    mixins: [userMixin],
    data () {
        return {
            table: {
                id: "stake-ward-table",
                fields: [
                    {
                        key: "ward_name",
                        label: "Name"
                    },
                    {
                        key: "ward_type",
                        label: 'Type'

                    },
                    {
                        key: "ward_city",
                        label: "Cities"
                    },
                    {
                        key: "action",
                        label: ""
                    }
                ],
                items: [],
                totalRows: 0,
                page: {
                    index: 1,
                    size: 5
                }
            },
            stakeInfo: {
                stake_name: "",
                stake_city: ""
            }
        }
    },
    async mounted() {
        await this.getStakeDetail();
        await this.getStake();
        this.$store.commit('ward/clearOrgFilter');
        

        //console.log("Mounted Stake Detail");
    },
    watch: {},
    computed: {},
    methods: {
        async getStakeDetail() {
            try
            {
                const { data } = await StakeApi.getStakeWardList(this.stakeId);
                this.table.items = data;
            } catch (e) {
                const msg = "Error getting Stake Ward List";
                handleError(e, msg);

            }

        },
        async getStake() {
            try{
                const { data } = await StakeApi.getStakeDetail(this.stakeId);
                //console.log(data);
                this.stakeInfo = data;
            }catch (e) {
                handleError(e, "Error fetching stake details");
            }
        },        
        async deleteWard(item) {
            try{
                const { data } = await StakeApi.deleteWard(this.stakeId, item.ward_id);
                await this.getStakeDetail();
            }catch(e){
                const msg = "Unable to delete ward";
                handleError(e, msg);
            }

        },
        async wardTools(item) {
            try {
                const {data} = await StakeApi.wardTools(item.ward_id);
                await this.getStakeDetail();
            } catch (e) {
                const msg = "Unable to perform ward tools";
                handleError(e, msg);
            }
        }
    }    
}
</script>
<style lang="scss" scoped>
</style>
